/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ProductInstance } from '../models/product-instance';
import { CustomerInstanceWithProducts } from '../models/customer-instance-with-products';
import { ProductInstanceWithStatus } from '../models/product-instance-with-status';
import { User } from '../models/user';
import { FileModel } from '../models/file-model';
@Injectable({
  providedIn: 'root',
})
class ProductInstanceService extends __BaseService {
  static readonly ProductInstanceCreateProductInstancePath = '/api/ProductInstance/CreateProductInstance';
  static readonly ProductInstanceGetProductInstancesByCustomerIdPath = '/api/ProductInstance/GetProductInstancesByCustomerId/{customerId}';
  static readonly ProductInstanceGetProductInstanceByIdPath = '/api/ProductInstance/GetProductInstanceById';
  static readonly ProductInstanceDeleteProductInstanceByIdPath = '/api/ProductInstance/DeleteProductInstanceById';
  static readonly ProductInstanceGetProductInstanceWithStatusPath = '/api/ProductInstance/GetProductInstanceWithStatus';
  static readonly ProductInstanceGetUsersByProductInstanceIdPath = '/api/ProductInstance/GetUsersByProductInstanceId';
  static readonly ProductInstanceListFilesPath = '/api/ProductInstance/ListFiles/{productInstanceId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `ProductInstanceService.ProductInstanceCreateProductInstanceParams` containing the following parameters:
   *
   * - `productId`:
   *
   * - `instanceName`:
   *
   * - `customerId`:
   */
  ProductInstanceCreateProductInstanceResponse(params: ProductInstanceService.ProductInstanceCreateProductInstanceParams): __Observable<__StrictHttpResponse<ProductInstance>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.productId != null) __params = __params.set('productId', params.productId.toString());
    if (params.instanceName != null) __params = __params.set('instanceName', params.instanceName.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ProductInstance/CreateProductInstance`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstance>;
      })
    );
  }
  /**
   * @param params The `ProductInstanceService.ProductInstanceCreateProductInstanceParams` containing the following parameters:
   *
   * - `productId`:
   *
   * - `instanceName`:
   *
   * - `customerId`:
   */
  ProductInstanceCreateProductInstance(params: ProductInstanceService.ProductInstanceCreateProductInstanceParams): __Observable<ProductInstance> {
    return this.ProductInstanceCreateProductInstanceResponse(params).pipe(
      __map(_r => _r.body as ProductInstance)
    );
  }

  /**
   * @param customerId undefined
   */
  ProductInstanceGetProductInstancesByCustomerIdResponse(customerId: number): __Observable<__StrictHttpResponse<CustomerInstanceWithProducts>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ProductInstance/GetProductInstancesByCustomerId/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerInstanceWithProducts>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  ProductInstanceGetProductInstancesByCustomerId(customerId: number): __Observable<CustomerInstanceWithProducts> {
    return this.ProductInstanceGetProductInstancesByCustomerIdResponse(customerId).pipe(
      __map(_r => _r.body as CustomerInstanceWithProducts)
    );
  }

  /**
   * @param productInstanceId undefined
   */
  ProductInstanceGetProductInstanceByIdResponse(productInstanceId?: number): __Observable<__StrictHttpResponse<ProductInstance>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productInstanceId != null) __params = __params.set('productInstanceId', productInstanceId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ProductInstance/GetProductInstanceById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstance>;
      })
    );
  }
  /**
   * @param productInstanceId undefined
   */
  ProductInstanceGetProductInstanceById(productInstanceId?: number): __Observable<ProductInstance> {
    return this.ProductInstanceGetProductInstanceByIdResponse(productInstanceId).pipe(
      __map(_r => _r.body as ProductInstance)
    );
  }

  /**
   * @param productInstanceId undefined
   */
  ProductInstanceDeleteProductInstanceByIdResponse(productInstanceId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productInstanceId != null) __params = __params.set('productInstanceId', productInstanceId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/ProductInstance/DeleteProductInstanceById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param productInstanceId undefined
   */
  ProductInstanceDeleteProductInstanceById(productInstanceId?: number): __Observable<Blob> {
    return this.ProductInstanceDeleteProductInstanceByIdResponse(productInstanceId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `ProductInstanceService.ProductInstanceGetProductInstanceWithStatusParams` containing the following parameters:
   *
   * - `productInstanceId`:
   *
   * - `productId`:
   */
  ProductInstanceGetProductInstanceWithStatusResponse(params: ProductInstanceService.ProductInstanceGetProductInstanceWithStatusParams): __Observable<__StrictHttpResponse<ProductInstanceWithStatus>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.productInstanceId != null) __params = __params.set('productInstanceId', params.productInstanceId.toString());
    if (params.productId != null) __params = __params.set('productId', params.productId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ProductInstance/GetProductInstanceWithStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceWithStatus>;
      })
    );
  }
  /**
   * @param params The `ProductInstanceService.ProductInstanceGetProductInstanceWithStatusParams` containing the following parameters:
   *
   * - `productInstanceId`:
   *
   * - `productId`:
   */
  ProductInstanceGetProductInstanceWithStatus(params: ProductInstanceService.ProductInstanceGetProductInstanceWithStatusParams): __Observable<ProductInstanceWithStatus> {
    return this.ProductInstanceGetProductInstanceWithStatusResponse(params).pipe(
      __map(_r => _r.body as ProductInstanceWithStatus)
    );
  }

  /**
   * @param productInstanceId undefined
   */
  ProductInstanceGetUsersByProductInstanceIdResponse(productInstanceId?: number): __Observable<__StrictHttpResponse<Array<User>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productInstanceId != null) __params = __params.set('productInstanceId', productInstanceId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ProductInstance/GetUsersByProductInstanceId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<User>>;
      })
    );
  }
  /**
   * @param productInstanceId undefined
   */
  ProductInstanceGetUsersByProductInstanceId(productInstanceId?: number): __Observable<Array<User>> {
    return this.ProductInstanceGetUsersByProductInstanceIdResponse(productInstanceId).pipe(
      __map(_r => _r.body as Array<User>)
    );
  }

  /**
   * @param productInstanceId undefined
   */
  ProductInstanceListFilesResponse(productInstanceId: number): __Observable<__StrictHttpResponse<Array<FileModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ProductInstance/ListFiles/${encodeURIComponent(String(productInstanceId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FileModel>>;
      })
    );
  }
  /**
   * @param productInstanceId undefined
   */
  ProductInstanceListFiles(productInstanceId: number): __Observable<Array<FileModel>> {
    return this.ProductInstanceListFilesResponse(productInstanceId).pipe(
      __map(_r => _r.body as Array<FileModel>)
    );
  }
}

module ProductInstanceService {

  /**
   * Parameters for ProductInstanceCreateProductInstance
   */
  export interface ProductInstanceCreateProductInstanceParams {
    productId?: number;
    instanceName?: null | string;
    customerId?: number;
  }

  /**
   * Parameters for ProductInstanceGetProductInstanceWithStatus
   */
  export interface ProductInstanceGetProductInstanceWithStatusParams {
    productInstanceId?: number;
    productId?: number;
  }
}

export { ProductInstanceService }
